<template>
  <div class="company-cruise-detail-block">
    <h2 class="company-cruise-detail-block-title">{{ title }}</h2>
    <slot />
  </div>
</template>

<script>
export default {
  name: "Block",
  props: {
    title: {
      type: String,
      default: ""
    }
  }
};
</script>

<style>

</style>
